/* ============
 * Actions for the auth module
 * ============
 *
 * The actions that are available on the
 * auth module.
 */

import Vue from 'vue';
// import store from '@/store';
import * as types from './mutation-types';

export const check = ({ commit }) => {
  commit(types.CHECK);
};

export const register = ({ commit }) => {
  /*
   * Normally you would use a proxy to register the user:
   *
   * new Proxy()
   *  .register(payload)
   *  .then((response) => {
   *    commit(types.REGISTER, response);
   *  })
   *  .catch(() => {
   *    console.log('Request failed...');
   *  });
   */
  commit(types.LOGIN, 'RandomGeneratedToken');
  Vue.router.push({
    name: 'my-account.index',
  });
};

// export const login = ({ commit }, payload) => {
//   Vue.$http.post('auth/login', payload.user).then((response) => {
//     commit(types.LOGIN, response.data);
//     Vue.router.push({
//       name: 'home.index',
//     });
//   });
// };

export const logout = ({ commit, dispatch }, loggedOut) => {
  dispatch('wait/start', 'global loading', { root: true });
  if (!loggedOut) {
    Vue.axios.post('auth/logout').then(() => {
      commit(types.LOGOUT);
      Vue.router.push({
        name: 'login.index',
      });
    });
  }
  commit(types.LOGOUT);
};

export default {
  check,
  // eslint-disable-next-line
  async register({ commit }, payload) {
    await Vue.$auth.register(payload.user).then((response) => {
      // commit(types.LOGIN, response.data);
      if (payload.successCallback) payload.successCallback(response.data);
      if (payload.redirect) {
        Vue.router.push({
          name: payload.redirect,
        });
      }
    }).catch(() => payload.callback());
    payload.callback();
  },
  async login({ commit }, payload) {
    await Vue.$auth.login(payload.user).then((response) => {
      commit(types.LOGIN, response.data);
      if (payload.successCallback) payload.successCallback();
      if (payload.redirect) {
        Vue.router.push({
          name: payload.redirect,
        });
      }
    }).catch(() => payload.callback());
    payload.callback();
  },
  logout,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js